module.exports = __webpack_public_path__ + "img/home-04.f1371308.svg";